
    <task-title *ngIf="ready$ | async"
                [task]="task$ | async"
                [project]="project$ | async"
                [boardName]="boardName$ | async"
                [columnName]="columnName$ | async"
    ></task-title>